// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { bynd } from './bynd';

export const touchfix = function () {
  const jsClass = 'has-js';
  const body = document.getElementsByTagName('body')[0];
  bynd.addClass(body, jsClass);

  if (!( 'ontouchstart' in document.documentElement )) {
    bynd.addClass(body, 'no-touch');
  }
};
